<template>
  <Ticket />
</template>

<script>
import Ticket from "@/components/ticketsRegistration/Ticket";

export default {
  name: "TicketPage",
  props: {},
  components: {
    Ticket,
  },
  data: () => ({}),
  computed: {},
  methods: {},
};
</script>
